export default {
	methods: {
		async handleShare(imageSrc, imageAlt = '', imageFilename = 'chat-image') {
			if (!imageSrc) {
				return
			}

			// Check if Web Share API is supported
			if (!navigator.share) {
				// Fallback: copy link to clipboard
				try {
					await navigator.clipboard.writeText(imageSrc)
					this.$stanNotify({
						type: 'success',
						title: this.$t('Success!'),
						text: this.$t('Image link copied to clipboard'),
					})
				} catch (error) {
					console.error('Failed to copy to clipboard:', error)
				}
				return
			}

			try {
				// Fetch the image as a blob
				const response = await fetch(imageSrc)
				const blob = await response.blob()

				// Create a File object from the blob
				const file = new File([blob], imageFilename, { type: blob.type })

				// Share the file using Web Share API
				await navigator.share({
					title: 'Shared Image',
					text: imageAlt || 'Check out this image',
					files: [file],
				})
			} catch (error) {
				if (error.name !== 'AbortError') {
					console.error('Error sharing:', error)
					// Fallback: copy link to clipboard
					try {
						await navigator.clipboard.writeText(imageSrc)
						this.$stanNotify({
							type: 'success',
							title: this.$t('Success!'),
							text: this.$t('Image link copied to clipboard'),
						})
					} catch (clipboardError) {
						console.error('Failed to copy to clipboard:', clipboardError)
					}
				}
			}
		},

		async handleDownload(imageSrc, imageFilename = 'chat-image') {
			if (!imageSrc) {
				return
			}

			try {
				// Fetch the image as a blob
				const response = await fetch(imageSrc)
				if (!response.ok) {
					throw new Error(`Failed to fetch image: ${response.status}`)
				}

				const blob = await response.blob()

				// Create a blob URL
				const blobUrl = URL.createObjectURL(blob)

				// Create a temporary link element to trigger download
				const link = document.createElement('a')
				link.href = blobUrl
				link.download = imageFilename
				link.style.display = 'none'

				// Append to body, click, and remove
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)

				// Clean up the blob URL
				URL.revokeObjectURL(blobUrl)
			} catch (error) {
				console.error('Error downloading image:', error)
				// Fallback to the original method
				const link = document.createElement('a')
				link.href = imageSrc
				link.download = imageFilename
				link.target = '_blank'
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			}
		},
	},
}
